import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { PatientInsightsCard } from './PatientInsightsCard';

// Navy blue matches the "Submit case" action colour used across the app's
// design system, so the chart reads as the submission stage of the pipeline.
const SUBMISSIONS_COLOR = '#3773A8';

interface SubmissionsInsightCardProps {
    practiceId: string;
}

export function SubmissionsInsightCard({ practiceId }: SubmissionsInsightCardProps) {
    return (
        <PatientInsightsCard
            practiceId={practiceId}
            metricLabel="Submissions"
            metric="submissions"
            icon={DocumentTextIcon}
            color={SUBMISSIONS_COLOR}
        />
    );
}
